export default "__VITE_ASSET__B_Hgxu6K__"